// extracted by mini-css-extract-plugin
module.exports = {"main":"ShoppingBag_main__2Cp7z","loading":"ShoppingBag_loading__jfHoR"};